import { FC, Fragment, ReactNode } from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "src/hooks/useAuth";

interface AuthGuardProps {
  children?: ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return <Fragment>{children}</Fragment>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
